module.exports = ["toEnglish","toEdition"]


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/langs.json
// module id = 810
// module chunks = 0